<template>
  <div class="referral-stage-item">
    <div v-if="item.isActive">
      <div class="referral-base-info">
        <referral-status-badge :status="item.application_status"></referral-status-badge>
        <span class="referral-date paragraph-xs paragraph-gray">
          {{ stageDate }}
        </span>
      </div>
      <p v-if="stageDescription"
         class="paragraph-s referral-description"
         v-html="stageDescription"></p>
    </div>
    <div v-else>
      <p class="paragraph-s paragraph-gray referral-status">
        {{ referralsMetaState.statuses && referralsMetaState.statuses[item.application_status] }}
      </p>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

import ReferralStatusBadge from '@/common/badges/ReferralStatusBadge';

export default {
  props: {
    item: {type: Object},
    refereeName: {type: String}
  },
  computed: {
    ...mapGetters(['referralsMetaState']),
    stageDescription() {
      let status = this.item.application_status;
      let name = this.refereeName;
      let stageDescriptions = {
        applied: this.$gettextInterpolate(this.$gettext("We received %{name}'s  application."), {name}),
        shortlisted: this.$gettextInterpolate(this.$gettext('%{name} was shortlisted for this position'), {name}),
        interview: this.$gettextInterpolate(this.$gettext('%{name} attended an interview.'), {name}),
        offer: this.$gettextInterpolate(this.$gettext('%{name} received the offer.'), {name}),
        hired: this.$gettextInterpolate(this.$gettext('Fantastic! %{name} accepted the offer.'), {name}),
        dismissed: this.$gettext("This opportunity didn't work out.")
      };

      return stageDescriptions[status] || '';
    },
    stageDate() {
      return this.$language.getFormattedDate(this.item.created);
    }
  },
  components: {
    ReferralStatusBadge,
  }
};
</script>

<style lang="scss" scoped>
.referral-base-info {
  padding-bottom: 10px;

  .referral-date {
    padding-left: 15px;
  }
}

.referral-description {
  margin-left: 5px;
}

.referral-status {
  padding-top: 2px;
  text-transform: uppercase;
}
</style>
